import dynamic from 'next/dynamic'
import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import styled from 'styled-components'
import BlogFooter from '../../components/blog/Footer'
import { gotoLogIn } from '../../redux/actions/AuthActions'
import { NAV } from '../../redux/constants'
import { setSelectedBubble } from '../../redux/designerReducers/canvasReducer'
import { fetchDesignGames } from '../../redux/designerReducers/designGamesReducer'
import { setNavbar } from '../../redux/designerReducers/designerReducer'
import { clearFilters } from '../../redux/designerReducers/itemsReducer'
import AIFeaturesSection from './components/AIFeaturesSection'
import AsSeenOnSection from './components/AsSeenOnSection'
import CTASection from './components/CTASection'
import DesignGamesSection from './components/DesignGamesSection'
import DesignIdeasSection from './components/DesignIdeasSection'
import FeaturesSection from './components/FeaturesSection'
import HeroSection from './components/HeroSection'
import RealRoomSection from './components/RealRoomSection'
import ReviewsHeaderSection from './components/ReviewsHeaderSection'
import ReviewsSection from './components/ReviewsSection'

const DesignerApp = dynamic(() => import('../Designs'), {
  ssr: false
})

const HomeWrapper = styled.div`
  width: 100%;
  min-height: 100vh;
  background: white;
`

const Home = ({ templates, challenges, inspirations }) => {
  const isAuthenticated = useSelector(state => state.auth.isAuthenticated)
  const dispatch = useDispatch()
  const { dailyTasks, welcomeTasks } = useSelector(state => state.checkIn)
  const userLoading = useSelector(state => state.profile.loading)

  const openLogin = () => {
    dispatch(gotoLogIn())
  }

  useEffect(() => {
    dispatch(setNavbar(NAV))
    dispatch(clearFilters())
    dispatch(setSelectedBubble(null))
    dispatch(fetchDesignGames())
  }, [dispatch])

  // If authenticated, show the designer app
  if (isAuthenticated) {
    if (userLoading) return null
    if (dailyTasks?.length === 0 || welcomeTasks?.length === 0) return null
    return <DesignerApp />
  }

  // Otherwise show the marketing homepage
  return (
    <HomeWrapper>
      <HeroSection onDownloadClick={openLogin} />
      <FeaturesSection onActionClick={openLogin} />
      <RealRoomSection onActionClick={openLogin} />
      <AIFeaturesSection onActionClick={openLogin} />
      <DesignIdeasSection inspirations={inspirations} />
      <DesignGamesSection onActionClick={openLogin} />
      <ReviewsHeaderSection />
      <AsSeenOnSection />
      <ReviewsSection />
      <CTASection />
      <BlogFooter />
    </HomeWrapper>
  )
}

export default Home
